import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackShowcaseSubpageRemoved.meta';

export const useTrackShowcaseSubpageRemoved = () => {
  const { track } = useAnalyticsUtilities();

  const trackShowcaseSubpageRemoved = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackShowcaseSubpageRemoved };
};
